import { useState } from "react";
import Modal from "react-modal";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "@mui/material";
import theme from "./assets/utils/them";
import AppRoutes from "./AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setAuthToken, setCurrentUser } from "./assets/redux/actions/User";
import UsersRequests from "./assets/services/user";
import appApi from "./assets/utils/AppApi";
import useLoginActions from "./assets/Hooks/Login";
import BackGroundAudio from "./assets/components/AudioPlayer";
import ChangeBackground from "./assets/components/ChangeBackground";
import IslandAudio from "./assets/components/AudioPlayer/IsalndAudio";
import UpdateBanner from "./assets/containers/UpdateBanner";
import useLocalStorage from "./assets/Hooks/getLocalStorageData";
import { useLocation } from "react-router";
import useHomeAddress from "./assets/Hooks/getHomeAddress";
import DownloadApplication from "./assets/containers/DownladApplication";
import { RouteProvider } from "./assets/context/RouteContext";
import VisitTracker from "./assets/components/VisitTracker";

function App() {
  Modal.setAppElement("#root");

  const dispatch = useDispatch();
  const { currentUser, userLevel } = useSelector(({ user }) => user);
  const { handleLogout } = useLoginActions();
  const [showVersionModal, setShowVersionModal] = useState(false);
  const [updateLink, setUpdateLink] = useState("");
  const { homeAddress } = useHomeAddress();

  const queryParameters = new URLSearchParams(window.location.search);
  const versionNum = queryParameters.get("version");
  const { version } = useLocalStorage();
  const { pathname } = useLocation();
  const localVersion = version === "null" ? JSON.parse(version) : version;

  const tokenRenew = async () => {
    try {
      await appApi.get(`/user/token/renew`).then(({ data }) => {
        localStorage.setItem("currentUser", data.user._id);
        localStorage.setItem("UserToken", data.token);
        dispatch(setAuthToken(data.token));
        dispatch(setCurrentUser(data.user));
      });
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          handleLogout();
        }
      } else {
        console.log(error);
      }
    }
  };

  const checkToken = async () => {
    try {
      await appApi.get(`/user/token/check`).then(({ data }) => {
        if (data.isTokenValid) {
          tokenRenew();
        } else {
          handleLogout();
        }
      });
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          handleLogout();
        }
      } else {
        console.log(error);
      }
    }
  };

  const checkVersion = async () => {
    try {
      await appApi.get(`/softwareinfo/android`).then(({ data }) => {
        if (data.latestVersion !== (versionNum ? versionNum : localVersion)) {
          setShowVersionModal(true);
          setUpdateLink(data.downloadLink);
        }
      });
    } catch (error) {
      if (error.response) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (versionNum || (localVersion && pathname === "/")) {
      checkVersion();
    }

    if (
      localStorage.getItem("UserToken") !== "" &&
      localStorage.getItem("currentUser") !== "" &&
      (pathname === "/" || pathname === homeAddress)
    ) {
      checkToken();
    }
  }, []);

  useEffect(() => {
    if (!currentUser?._id && userLevel === null) {
      dispatch(UsersRequests.getUserPoint());
    }
  }, [currentUser, userLevel, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <RouteProvider>
        <VisitTracker />
        <UpdateBanner show={showVersionModal} link={updateLink} />
        <DownloadApplication />
        <IslandAudio />
        <AppRoutes />
        <BackGroundAudio />
        <ChangeBackground />
        <Toaster
          toastOptions={{
            style: {
              direction: "rtl",
              textAlign: "right",
            },
          }}
        />
      </RouteProvider>
    </ThemeProvider>
  );
}

export default App;
